// extracted by mini-css-extract-plugin
module.exports = {"sliderBlock":"Range_sliderBlock__1HkOo","thumb":"Range_thumb__2EpzW","slideThrought":"Range_slideThrought__2hFbi"};